<template>
  <div class="carousel">
    <button
      @click="onLeftClick"
      class="carousel__button carousel__button--left is-hidden"
    >
      <img
        class="carousel__button__image"
        src="../../assets/images/card-button/previous.png"
        alt="previous button"
      />
    </button>
    <div class="carousel__track-nav-container">
      <div class="carousel__track-container">
        <ul class="carousel__track">
           <li
            :class="
              index === 0 ? 'carousel-slide current-slide' : 'carousel-slide'
            "
            v-for="(product, index) in validProducts"
            :key="index"
            
          >
            <Card
              :imageUrl="product.PhotoUrl ? product.PhotoUrl : imageList[index]"
              :cardContent="product.Name"
              :cardValue="product.Price"
              :colorStyle="index === 1 ? '#5D77BC' : ''"
              variant="normal"
            />
          </li>
          <!-- <li
            :class="
              index === 0 ? 'carousel-slide current-slide' : 'carousel-slide'
            "
            v-for="(imageUrl, index) in imageUrlList"
            :key="imageUrl"
          >
            <Card
              :imageUrl="imageUrl"
              :cardContent="cardContentList[index]"
              :cardValue="selectedCardValue"
              :colorStyle="index === 1 ? '#5D77BC' : ''"
              variant="normal"
            />
          </li> -->
        </ul>
      </div>

      <div @click="onNavClick" class="carousel__nav">
        <button
          v-for="(product, index) in validProducts"
          class="carousel__preview__button"
          :class="{ current__preview: index === currentSlidIndex }"
          :key="index"
          :data-giftid="product.ProductID"
        >
          <Card
            :imageUrl="product.PhotoUrl ? product.PhotoUrl : imageList[index]"
            :cardContent="cardContentList[index]"
            :cardValue="selectedCardValue"
            :colorStyle="index === 1 ? '#5D77BC' : ''"
            :contentSize="5"
          />
        </button>
        <!-- <button
          v-for="(imageUrl, index) in imageUrlList"
          class="carousel__preview__button"
          :class="{ current__preview: index === currentSlidIndex }"
          :key="index"
        >
          <Card
            :imageUrl="imageUrl"
            :cardContent="cardContentList[index]"
            :cardValue="selectedCardValue"
            :colorStyle="index === 1 ? '#5D77BC' : ''"
            :contentSize="5"
          />
        </button> -->
      </div>
    </div>
    <button
      @click="onRightClick"
      class="carousel__button carousel__button--right"
    >
      <img
        class="carousel__button__image"
        src="../../assets/images/card-button/next.png"
        alt="previous button"
      />
    </button>
  </div>
</template>

<script lang="ts">
import { $$ } from "./../../sharedscripts/OO_jquery";
import Card from "./Card.vue";

export default {
  name: "CustomCarousel",
  components: {
    Card,
  },
  props: {
    imageUrlList: {
      required: true,
      type: Array,
    },
    cardContentList: {
      required: true,
      type: Array,
    },
    selectedCardValue: {
      required: true,
      type: Number,
    },
    storemenu: {
      type: Object,
      default: () => {},
    },
    selectedGiftCardId: {
      type: Number,
      default: null,
    }
  },
 data() {
  return {
     baseUrl: "../",
     track:null,
     slides:null ,
     previewNav:null ,
     previews:null,
     slideWidth:null ,
     baseLeft:null,
     leftButton:null,
     rightButton:null,
     currentSlidIndex:0,
     imageList:[],
    };
  },
  computed: {
    validProducts() {
      let temp = [];
      this.storemenu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach(
        (element) => {
          if (this.storemenu.Products[element.ProductID]) {
            temp.push(element);
          }
        }
      );
      this.populateimageList(temp.length);
      return temp;
    },
  },
  mounted() {
      this.track = document.querySelector(".carousel__track");
      this.slides = Array.from(this.track.children);
      this.previewNav = document.querySelector(".carousel__nav");
      this.previews = Array.from(this.previewNav.children);
      this.slideWidth = this.slides[0].getBoundingClientRect().width;
      this.leftButton = document.querySelector(".carousel__button--left");
      this.rightButton = document.querySelector(".carousel__button--right");

      // helper function for calculating the track move amount
      const setSlidePosition = (slide, index) => {
        this.baseLeft =
          document.querySelector(".carousel__track").getBoundingClientRect()
            .width /
            2 -
          this.slideWidth / 2;
        slide.style.left =
          this.baseLeft + this.slideWidth * index + "px";
      };
      // extract proxy result to an object
      const target_copy = Object.assign({}, this.slides);
      // convert object to an array
      const slides_array_result = Object.values(target_copy);

      slides_array_result.forEach(setSlidePosition);
    },
  watch: {
    selectedGiftCardId() {
      if(this.selectedGiftCardId)
      {
        this.populateselected();
      }
    }
    
  },
  methods: {
    populateselected(){
      var productIndex = this.validProducts.findIndex(x => x.ProductID == this.selectedGiftCardId);
      var product = this.validProducts[productIndex];
      const targetPreview = $$(".carousel__nav").find('[data-giftid="'+product.ProductID+'"]');
      //const targetPreview = $$(clickedElement).closest("button");

      if (!targetPreview) {
        return;
      }
      // extract proxy result to an object
      const target_copy = Object.assign({}, this.previews);
      // convert object to an array
      const previews_array_result = Object.values(target_copy);

      const slides_target_copy = Object.assign({}, this.slides);
      const slides_array_result = Object.values(slides_target_copy);
      
      const currentSlide = this.track.querySelector(".current-slide");
      const currentPreview =
        this.previewNav.querySelector(".current__preview");
      const targetIndex = previews_array_result.findIndex(
        (preview) => preview === targetPreview[0]
      );
      this.currentSlidIndex = targetIndex;
      const targetSlide = slides_array_result[targetIndex];

      this.moveToSlide(this.track, currentSlide, targetSlide);
      this.updatePreview(currentPreview, targetPreview[0]);

      this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, targetIndex);
      this.$emit("selecteditem", product);
    },
    populateimageList(count) {
      this.imageList = this.imageUrlList;
      if(count > this.imageUrlList.length)
      {
        var plus = ((count - this.imageUrlList.length) % this.imageUrlList.length) * 2;
        for(var i = 1; i <= plus; i++){
          this.imageList.push(this.imageUrlList);
        }
      }
    },
    // helper function to calculate the amount to move
    moveToSlide(track, currentSlide, targetSlide) {
      track.style.transform =
        "translateX(-" + targetSlide.style.left + ")";

      currentSlide.classList.remove("current-slide");
      targetSlide.classList.add("current-slide");
    },

    // helper function to change current preview
    updatePreview(currentPreview, targetPreview){
      currentPreview.classList.remove("current__preview");
      targetPreview.classList.add("current__preview");
    },

    hideShowArrows(
      slides_array_result,
      leftButton,
      rightButton,
      targetIndex
    ) {
      if (targetIndex === 0) {
        leftButton.classList.add("is-hidden");
        rightButton.classList.remove("is-hidden");
      } else if (targetIndex === slides_array_result.length - 1) {
        leftButton.classList.remove("is-hidden");
        rightButton.classList.add("is-hidden");
      } else {
        leftButton.classList.remove("is-hidden");
        rightButton.classList.remove("is-hidden");
      }
    },

    onLeftClick () {
      const currentSlide = this.track.querySelector(".current-slide");
      const prevSlide = currentSlide.previousElementSibling;
      const slides_target_copy = Object.assign({}, this.slides);
      const slides_array_result = Object.values(slides_target_copy);
      const currentPreview =
        this.previewNav.querySelector(".current__preview");
      const prevPreview = currentPreview.previousElementSibling;
      const prevIndex = slides_array_result.findIndex(
        (slide) => slide === prevSlide
      );
      this.currentSlidIndex = prevIndex;
      this.moveToSlide(this.track, currentSlide, prevSlide);
      this.updatePreview(currentPreview, prevPreview);

      this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, prevIndex);
      this.$emit("targetIndex", prevIndex);
      this.$emit("selecteditem", this.validProducts[prevIndex]);
    },

    onRightClick() {
      const slides_target_copy = Object.assign({}, this.slides);
      const slides_array_result = Object.values(slides_target_copy);
      const currentSlide = this.track.querySelector(".current-slide");
      const nextSlide = currentSlide.nextElementSibling;
      const currentPreview =
        this.previewNav.querySelector(".current__preview");
      const nextPreview = currentPreview.nextElementSibling;
      const nextIndex = slides_array_result.findIndex(
        (slide) => slide === nextSlide
      )
      this.currentSlidIndex = nextIndex;
      this.moveToSlide(this.track, currentSlide, nextSlide);
      this.updatePreview(currentPreview, nextPreview);

      this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, nextIndex);
      this.$emit("targetIndex", nextIndex);
      this.$emit("selecteditem", this.validProducts[nextIndex]);

    },

    onNavClick(e) {
      var clickedElement = e.target;
      const targetPreview = $$(clickedElement).closest("button");

      if (!targetPreview) {
        return;
      }
      // extract proxy result to an object
      const target_copy = Object.assign({}, this.previews);
      // convert object to an array
      const previews_array_result = Object.values(target_copy);

      const slides_target_copy = Object.assign({}, this.slides);
      const slides_array_result = Object.values(slides_target_copy);
      
      const currentSlide = this.track.querySelector(".current-slide");
      const currentPreview =
        this.previewNav.querySelector(".current__preview");
      const targetIndex = previews_array_result.findIndex(
        (preview) => preview === targetPreview[0]
      );
      this.currentSlidIndex = targetIndex;
      const targetSlide = slides_array_result[targetIndex];

      this.moveToSlide(this.track, currentSlide, targetSlide);
      this.updatePreview(currentPreview, targetPreview[0]);

      this.hideShowArrows(slides_array_result, this.leftButton, this.rightButton, targetIndex);
      this.$emit("targetIndex", targetIndex);
      this.$emit("selecteditem", this.validProducts[targetIndex]);
    },
  }
};
</script>

<style scoped>
.carousel__track-nav-container {
  height: 100%;
  margin: 0 auto;
  width: 68%;
}
.carousel__preview__image {
  height: 100%;
  width: 100%;
}
.carousel__preview__button {
  height: 100%;
  border: 0;
  background: transparent;
}
.current__preview {
  border: 2px solid #55a7ff;
  border-radius: 9px;
}
.carousel__nav {
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 10px;
}
.carousel__nav > * {
  width: 100%;
  flex: 1;
  margin: 0 5px;
}
.carousel__preview__button:first-child {
  margin-left: 0;
}
.carousel__preview__button:last-child {
  margin-right: 0;
}
.carousel {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  width: 100%;
  flex: 0 0 auto;
}
.carousel__track-container {
  height: 80%;
  overflow: hidden;
  /* width: 68%; */
  min-width: 312px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.carousel-slide {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
.carousel__track {
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  list-style-type: none;
  transition: transform 250ms ease-in;
}
.carousel__button {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  background: transparent;
  border: 0;
  cursor: pointer;
}
.carousel__button:focus {
  outline: none;
}
.carousel__button--left {
  z-index: 1;
  left: 3%;
}
.carousel__button--right {
  right: 3%;
}
.carousel__button__image {
  width: 50%;
}
.is-hidden {
  display: none;
}
@media only screen and (max-width: 900px) {
  .carousel__track-container {
    height: 75%;
  }
  .carousel__button--left {
    left: -8%;
  }
  .carousel__button--right {
    right: -8%;
  }
  .carousel__track-nav-container {
    width: 310px;
  }
}
@media only screen and (max-width: 600px) {
  .carousel__nav {
    width: 260px;
  }
  .carousel__button--left {
    left: -3%;
  }
  .carousel__button--right {
    right: -3%;
  }
}

</style>
